/* ─────────────────────────────────────────────────────────────────────────
   Vinanest — seasonal promo runtime (shared by home / collection / product / cart)
   Config: window.VINANEST_PROMO from snippets/vinanest-promo-js.liquid, which reads
   Theme settings → "Vinanest — Promo" (code, %, end date, hero image).
   Strings below are merged into each page's I18N table (all four languages);
   {code} and {pct} placeholders are filled from the config at render time.
   Loaded with `defer` BEFORE vinanest-landing.js / vinanest-product.js.
   ───────────────────────────────────────────────────────────────────────── */
(function(){
  var P = window.VINANEST_PROMO || {};

  /* Quiz data is injected by the section with Liquid's `money` filter; currency apps wrap that
     in <span class=trans-money>…</span>. Strip any markup so the price renders as plain text. */
  if (window.VINANEST_QUIZ && VINANEST_QUIZ.forEach) {
    VINANEST_QUIZ.forEach(function(q){ if (q && q.price) q.price = String(q.price).replace(/<[^>]*>/g, "").trim(); });
  }

  window.VINANEST_I18N_EXTRA = {
    vi: {
      tt_eyebrow:"Tết Trung Thu 2026 · Ưu Đãi Đặc Biệt",
      tt_h1:"Trung Thu Trọn Vẹn,<br><em>Giảm {pct}%</em><br>Toàn Bộ Sản Phẩm",
      tt_p:"Mùa trăng tròn — mùa của sum vầy và những món quà sức khỏe. Giảm {pct}% cho mọi đơn hàng với mã <b>{code}</b>, miễn phí giao hàng toàn nước Mỹ.",
      tt_code_l:"Mã ưu đãi", tt_copy:"Sao chép", tt_copied:"Đã sao chép ✓",
      tt_cta1:"Mua Ngay · Giảm {pct}%", tt_cta2:"Quà Tặng Trung Thu",
      tt_ends:"Ưu đãi kết thúc trong", tt_d:"Ngày", tt_h:"Giờ", tt_m:"Phút", tt_s:"Giây", tt_over:"Ưu đãi đã kết thúc",
      nav_promo:"Trung Thu −{pct}%",
      ticker_promo:"Tết Trung Thu · Giảm {pct}% toàn bộ với mã <b>{code}</b> · Miễn phí giao hàng toàn nước Mỹ",
      badge_promo:"Trung Thu −{pct}%",
      cart_promo:"Mã <b>{code}</b> · giảm {pct}% được áp dụng tại thanh toán",
      pdp_promo:"Tết Trung Thu: giảm {pct}% toàn bộ với mã <b>{code}</b> — tự động áp dụng khi thanh toán",
      bun_promo:"Trung Thu: giảm {pct}% toàn bộ với mã {code} — nhiều hơn cả ưu đãi bộ",
      coll_promo:"Tết Trung Thu · Giảm {pct}% toàn bộ",
      gift_l_tt:"Quà Tặng Trung Thu", gift_h_tt:"Trăng Tròn, <em>Sum Vầy</em> &amp; Sức Khỏe",
      gift_p1_tt:"Trung Thu là dịp đoàn viên — và một hộp tổ yến Vinanest là lời chúc sức khỏe trang trọng nhất gửi đến ông bà, cha mẹ. Mùa này, mọi sản phẩm đều được giảm {pct}% với mã {code}.",
      gift_cta_tt:"Chọn Quà Trung Thu · −{pct}%", gift_cta:"Xem Quà Tặng", go0:"Tết Trung Thu",
      foot_l3:"Quà Tặng Sức Khỏe", foot_l9:"Điều Khoản Dịch Vụ",
      bun_t1:"Chọn 2 · giảm <b>5%</b>", bun_t2:"Chọn 3 trở lên · giảm <b>10%</b>",
      vs5:"Giao hàng miễn phí toàn nước Mỹ cho mọi đơn", vs_rare:"Thường tính phí"
    },
    en: {
      tt_eyebrow:"Mid-Autumn Festival 2026 · Limited Offer",
      tt_h1:"A Full-Moon Gift,<br><em>{pct}% Off</em><br>Everything",
      tt_p:"The season of reunion and gifts of health. Take {pct}% off every order with code <b>{code}</b> — free US shipping included.",
      tt_code_l:"Offer code", tt_copy:"Copy", tt_copied:"Copied ✓",
      tt_cta1:"Shop {pct}% Off", tt_cta2:"Mid-Autumn Gifts",
      tt_ends:"Offer ends in", tt_d:"Days", tt_h:"Hours", tt_m:"Min", tt_s:"Sec", tt_over:"This offer has ended",
      nav_promo:"Mid-Autumn −{pct}%",
      ticker_promo:"Mid-Autumn Festival · {pct}% off everything with code <b>{code}</b> · Free US shipping",
      badge_promo:"Mid-Autumn −{pct}%",
      cart_promo:"Code <b>{code}</b> · {pct}% off is applied at checkout",
      pdp_promo:"Mid-Autumn Festival: {pct}% off everything with code <b>{code}</b> — applied automatically at checkout",
      bun_promo:"Mid-Autumn: {pct}% off everything with code {code} — better than the bundle tiers",
      coll_promo:"Mid-Autumn Festival · {pct}% off everything",
      gift_l_tt:"Mid-Autumn Gifting", gift_h_tt:"Full Moon, <em>Reunion</em> &amp; Good Health",
      gift_p1_tt:"Tết Trung Thu is the season of gathering — and a box of Vinanest bird's nest is the most gracious wish of health you can give parents and grandparents. This season, everything is {pct}% off with code {code}.",
      gift_cta_tt:"Choose A Mid-Autumn Gift · −{pct}%", gift_cta:"Explore Gifts", go0:"Mid-Autumn Festival",
      foot_l3:"Gift Boxes", foot_l9:"Terms of Service",
      bun_t1:"Pick 2 · save <b>5%</b>", bun_t2:"Pick 3 or more · save <b>10%</b>",
      vs5:"Free US shipping on every order", vs_rare:"Usually extra"
    },
    zh: {
      tt_eyebrow:"2026 中秋节 · 限时优惠",
      tt_h1:"月圆人团圆，<br><em>全场立减 {pct}%</em>",
      tt_p:"团圆的季节，献上健康之礼。使用优惠码 <b>{code}</b>，全场订单立减 {pct}%，全美免运费。",
      tt_code_l:"优惠码", tt_copy:"复制", tt_copied:"已复制 ✓",
      tt_cta1:"立即选购 · 减 {pct}%", tt_cta2:"中秋礼品",
      tt_ends:"优惠倒计时", tt_d:"天", tt_h:"时", tt_m:"分", tt_s:"秒", tt_over:"优惠已结束",
      nav_promo:"中秋 −{pct}%",
      ticker_promo:"中秋节 · 优惠码 <b>{code}</b> 全场立减 {pct}% · 全美免运费",
      badge_promo:"中秋 −{pct}%",
      cart_promo:"优惠码 <b>{code}</b> · 结账时自动减 {pct}%",
      pdp_promo:"中秋节：优惠码 <b>{code}</b> 全场立减 {pct}% — 结账时自动应用",
      bun_promo:"中秋：优惠码 {code} 全场立减 {pct}% — 优于套装折扣",
      coll_promo:"中秋节 · 全场立减 {pct}%",
      gift_l_tt:"中秋送礼", gift_h_tt:"月圆、<em>团圆</em>与健康",
      gift_p1_tt:"中秋是团圆的时节——一盒 Vinanest 燕窝，是献给父母长辈最郑重的健康祝福。本季全场使用优惠码 {code} 立减 {pct}%。",
      gift_cta_tt:"挑选中秋礼品 · 减 {pct}%", gift_cta:"查看礼品", go0:"中秋节",
      foot_l3:"健康礼盒", foot_l9:"服务条款",
      bun_t1:"选2件 · 享<b>95折</b>", bun_t2:"选3件以上 · 享<b>9折</b>",
      vs5:"全美订单免运费", vs_rare:"通常另收费"
    },
    "zh-tw": {
      tt_eyebrow:"2026 中秋節 · 限時優惠",
      tt_h1:"月圓人團圓，<br><em>全場立減 {pct}%</em>",
      tt_p:"團圓的季節，獻上健康之禮。使用優惠碼 <b>{code}</b>，全場訂單立減 {pct}%，全美免運費。",
      tt_code_l:"優惠碼", tt_copy:"複製", tt_copied:"已複製 ✓",
      tt_cta1:"立即選購 · 減 {pct}%", tt_cta2:"中秋禮品",
      tt_ends:"優惠倒數", tt_d:"天", tt_h:"時", tt_m:"分", tt_s:"秒", tt_over:"優惠已結束",
      nav_promo:"中秋 −{pct}%",
      ticker_promo:"中秋節 · 優惠碼 <b>{code}</b> 全場立減 {pct}% · 全美免運費",
      badge_promo:"中秋 −{pct}%",
      cart_promo:"優惠碼 <b>{code}</b> · 結帳時自動減 {pct}%",
      pdp_promo:"中秋節：優惠碼 <b>{code}</b> 全場立減 {pct}% — 結帳時自動套用",
      bun_promo:"中秋：優惠碼 {code} 全場立減 {pct}% — 優於套裝折扣",
      coll_promo:"中秋節 · 全場立減 {pct}%",
      gift_l_tt:"中秋送禮", gift_h_tt:"月圓、<em>團圓</em>與健康",
      gift_p1_tt:"中秋是團圓的時節——一盒 Vinanest 燕窩，是獻給父母長輩最鄭重的健康祝福。本季全場使用優惠碼 {code} 立減 {pct}%。",
      gift_cta_tt:"挑選中秋禮品 · 減 {pct}%", gift_cta:"查看禮品", go0:"中秋節",
      foot_l3:"健康禮盒", foot_l9:"服務條款",
      bun_t1:"選2件 · 享<b>95折</b>", bun_t2:"選3件以上 · 享<b>9折</b>",
      vs5:"全美訂單免運費", vs_rare:"通常另收費"
    }
  };

  /* Fill {code} / {pct} placeholders — used by applyLang() on every page. */
  function tpl(s){
    if (typeof s !== "string") return s;
    return s.replace(/\{code\}/g, P.code || "").replace(/\{pct\}/g, (P.pct != null ? P.pct : ""));
  }
  window.vnPromoTpl = tpl;

  function dict(){ try { return I18N[currentLang] || I18N.vi; } catch(e){ return null; } }

  /* Copy the offer code (hero pill, collection banner, product page). */
  window.vnCopyCode = function(btn){
    var code = String(P.code || (document.getElementById("promoCode") || {}).textContent || "").trim();
    var done = function(){
      var d = dict(), t = (d && d.tt_copied) || "✓";
      var old = btn.innerHTML;
      btn.innerHTML = t; btn.classList.add("ok");
      setTimeout(function(){ btn.innerHTML = old; btn.classList.remove("ok"); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      try {
        var ta = document.createElement("textarea"); ta.value = code; ta.setAttribute("readonly", "");
        ta.style.position = "fixed"; ta.style.opacity = "0"; document.body.appendChild(ta);
        ta.select(); document.execCommand("copy"); document.body.removeChild(ta);
      } catch(e){}
      done();
    }
  };

  /* Hero countdown to the promo end (Theme settings → promo_ends, ISO 8601 UTC). */
  var cd = document.getElementById("promoCountdown");
  if (cd && P.ends) {
    var end = new Date(P.ends).getTime();
    var D = document.getElementById("cdD"), H = document.getElementById("cdH"), M = document.getElementById("cdM"), S = document.getElementById("cdS");
    var pad = function(n){ return (n < 10 ? "0" : "") + n; };
    var iv = null;
    var tick = function(){
      var ms = end - Date.now();
      if (isNaN(ms)) { cd.style.display = "none"; if (iv) clearInterval(iv); return; }
      if (ms <= 0) {
        cd.classList.add("over");
        var l = cd.querySelector(".cd-l"), d = dict();
        if (l) { l.setAttribute("data-i18n", "tt_over"); l.innerHTML = (d && d.tt_over) || "Ưu đãi đã kết thúc"; }
        var t = cd.querySelector(".cd-tiles"); if (t) t.style.display = "none";
        if (iv) clearInterval(iv);
        return;
      }
      var s = Math.floor(ms / 1000), dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
      if (D) D.textContent = dd; if (H) H.textContent = pad(hh); if (M) M.textContent = pad(mm); if (S) S.textContent = pad(ss);
    };
    tick(); iv = setInterval(tick, 1000);
  }
})();
